import { createSelector } from 'reselect'

import { usersPageSelector } from '../selectors'

export const sliceSelector = createSelector(usersPageSelector, ({ pending }) => pending)
const removeInvitationsPopupSelector = createSelector(sliceSelector, ({ removeInvitationsPopup }) => removeInvitationsPopup)
export const paginationSelector = createSelector(sliceSelector, ({ pagination }) => pagination)
export const isLoadingSelector = createSelector(sliceSelector, ({ isLoading }) => isLoading)

export const isRemoveInvitationsPopupOpenSelector = createSelector(
  removeInvitationsPopupSelector,
  (removeInvitationsPopup) => removeInvitationsPopup.isOpen
)

export const removeInvitationsPopupMembersSelector = createSelector(
  removeInvitationsPopupSelector,
  (removeInvitationsPopup) => removeInvitationsPopup.members
)

export const selectedIdsSelector = createSelector(
  sliceSelector,
  ({ selectedInvitations }) => selectedInvitations.map(({ id }) => id)
)

export const invitationsSelector = createSelector(
  sliceSelector,
  selectedIdsSelector,
  ({ invitations }, selectedIds) => invitations.map((invitation) => ({
    ...invitation,
    is_selected: selectedIds.includes(invitation.id)
  }))
)

export const selectAllStatusSelector = createSelector(
  sliceSelector,
  ({ selectAll }) => selectAll
)

export const excludedIdsSelector = createSelector(
  sliceSelector,
  ({ excludedIds }) => excludedIds
)

export const selectedEntitiesCountSelector = createSelector(
  sliceSelector,
  ({ selectedInvitations }) => selectedInvitations.length
)

export const batchCheckboxStatusSelector = createSelector(
  selectedEntitiesCountSelector,
  invitationsSelector,
  (selectedEntitiesCount, invitations) => {
    if (selectedEntitiesCount === 0) {
      return 'none'
    } if (selectedEntitiesCount === invitations.length) {
      return 'all'
    }
    return 'some'
  }
)

export const filterTermSelector = createSelector(
  sliceSelector,
  ({ filter }) => filter
)

export const canRemoveInvitations = createSelector(
  sliceSelector,
  ({ selectedInvitations }) => selectedInvitations.every(({ policy }) => policy.destroy)
)

export const sortFieldSelector = createSelector(sliceSelector, ({ sortField }) => sortField)
export const sortOrderSelector = createSelector(sliceSelector, ({ sortOrder }) => sortOrder)
export const isEndlessScrollEnabledSelector = createSelector(sliceSelector, ({ isEndlessScrollEnabled }) => isEndlessScrollEnabled)
